import React from 'react';
import ResultModal from '../../ResultModal/ResultModal';
import BooleanQuestion from '../../Questions/BooleanQuestion';
import MultipleChoiceQuestion from '../../Questions/MultipleChoiceQuestion';
import BooleanChoices from '../../Choices/BooleanChoices';
import MultipleChoices from '../../Choices/MultipleChoices';
import questions from '../../../data/questions';
import Footer from '../../Footer/Footer';


function shuffle(array) {
    let currentIndex = array.length;
    let temporaryValue;
    let randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }

    return array;
}

let questionList = shuffle(questions);

function getRandomQuestion(index) {
    return questionList[index];
}


export default class GamePage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            questionsShown: 0,
            correctAnswers: 0,
            randomQuestion: getRandomQuestion(0),
            showModal: false,
            isAnswerCorrect: false
        };


        this.handleAnswer = this.handleAnswer.bind(this);
        this.generateChoices = this.generateChoices.bind(this);
        this.getRandomQuestion = this.getRandomQuestion.bind(this);
        this.handleShowNextQuestion = this.handleShowNextQuestion.bind(this);
        this.handleTryAgain = this.handleTryAgain.bind(this);
    }

    getRandomQuestion() {
        let questionsShown = this.state.questionsShown + 1;
        const randomQuestion = getRandomQuestion(questionsShown);
        if (!randomQuestion || questionsShown >= 10) {
            const result = {
                correctAnswers: this.state.correctAnswers,
                questionsShown: this.state.questionsShown
            };
            // this.props.onGameOver(result);

            return;
        }

        this.setState({
            randomQuestion,
            showModal: false,
            isAnswerCorrect: false,
            questionsShown: questionsShown
        });
    }

    handleAnswer(answerId) {
        const isAnswerCorrect = answerId === this.state.randomQuestion.answerId;
        let currentCorrectAnswers = this.state.correctAnswers;

        let questionsShown = this.state.questionsShown + 1;

        if (isAnswerCorrect) {
            currentCorrectAnswers++;
        }

        this.setState({
            correctAnswers: currentCorrectAnswers,
            questionsShown,
            showModal: true,
            isAnswerCorrect
        });
    }

    handleTryAgain() {
        if (this.state.questionsShown >= 10) {

            const result = {
                correctAnswers: this.state.correctAnswers,
                questionsShown: this.state.questionsShown
            };

            // this.props.onGameOver(result);
            this.setState({
                showModal: false
            });
            return;
        }

        this.setState({
            showModal: false
        });
    }

    handleShowNextQuestion() {
        const randomQuestion = getRandomQuestion(this.state.questionsShown);

        if (!randomQuestion || this.state.questionsShown >= 10) {

            const result = {
                correctAnswers: this.state.correctAnswers,
                questionsShown: this.state.questionsShown
            };

            //     this.props.onGameOver(result);
            this.setState({
                showModal: false
            });
            return;
        }

        this.setState({
            randomQuestion,
            showModal: false,
            isAnswerCorrect: false
        });
    }

    generateQuestion(question) {

        switch (question.questionType) {
            case 'boolean':
                return (
                    <BooleanQuestion randomQuestion={question}/>
                );
            case 'multiple-choice':
                return (
                    <MultipleChoiceQuestion randomQuestion={question}/>
                );
            default:
                return '';
        }
    }

    generateChoices(question) {
        switch (question.questionType) {
            case 'boolean':
                return (
                    <BooleanChoices handleAnswer={this.handleAnswer}/>
                );
            case 'multiple-choice':
                return (
                    <MultipleChoices choices={question.choices} handleAnswer={this.handleAnswer}/>
                );
            default:
                return '';
        }
    }

    render() {
        const question = this.generateQuestion(this.state.randomQuestion);
        const choices = this.generateChoices(this.state.randomQuestion);

        return (
            <div>
                <div className="container-fluid" id="question-container">
                    <div className="row justify-content-md-center">
                        {question}
                    </div>
                    {choices}
                    <div id="footer" className="row">
                        <div className="col">
                        </div>
                    </div>
                    <ResultModal
                        question={this.state.randomQuestion}
                        showNextQuestion={this.handleShowNextQuestion}
                        isAnswerCorrect={this.state.isAnswerCorrect}
                        showModal={this.state.showModal}
                        questionsShown={this.state.questionsShown}
                        correctAnswers={this.state.correctAnswers}
                        tryAgain={this.handleTryAgain}
                    />
                </div>
                <Footer/>
            </div>
        );
    }

}
